import DirectoryService from '../directory/DirectoryService';
import DocumentService from '../documents/DocumentService';
import SoftwareLicenceService from '../software-licences/SoftwareLicenceService';
const OnBoardingService = {
  createOnBoardingTask: async taskData => {
    const url = '/api/todo/profile/' + taskData.profileIdentifier;
    try {
      const response = await fetch(
        url,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(taskData)
        }
      );
      if (!response.ok) {
        throw new Error(`Failed creating onboarding task: ${response.status}`);
      }
      const data = await response.json();
      console.log('Onboarding task created:', data);
      return data;
    } catch (error) {
      console.error('Error creating onboarding task:', error);
      throw error;
    }
  },
    autoGenerateOnBoardingMock: async employee => {
    return new Promise(resolve => {
      setTimeout(() => {
        const mockData = {
          tasks: [
            {
              id: '1',
              text: 'Complete HR paperwork',
              done: false,
              profileIdentifier: employee.identifier
            },
            {
              id: '2',
              text: 'Set up workstation',
              done: false,
              profileIdentifier: employee.identifier
            },
            {
              id: '3',
              text: 'Attend orientation session',
              done: false,
              profileIdentifier: employee.identifier
            }
          ]
        };
        resolve(mockData.tasks);
      }, 2000); // Simulate a 2-second delay for the mock profileResponse
    }
    );
  },    
  markOnboardingTaskAsReviewed: async (identifier) => {
    try {
      const response = await fetch(
        '/api/todo/' + identifier + '/markAsReviewed',
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      if (!response.ok) {
        throw new Error(`Failed marking task as reviewed: ${response.status}`);
      }
      console.log('Task marked as reviewed:', identifier);
    } catch (error) {
      console.error('Error marking task as reviewed:', error);
      throw error;
    }
  },  
  autoGenerateOnBoarding: async employee => {
    const accountIdentifier = JSON.parse(
      localStorage.getItem('profile')
    ).accountIdentifier;
    const profiles = await DirectoryService.retrieveProfilesByAccountIdentifier(
      accountIdentifier
    );
        
    const available_docs = await DocumentService.retrieveDocumentsByAccountIdentifier(accountIdentifier);
    if (available_docs.length < 3) {
      throw new Error('Not enough documents available for onboarding generation');
    }
    const software_list = await SoftwareLicenceService.retrieveAllSoftwareLicenceByAccount();
    if (software_list.length < 2) {
      throw new Error('Not enough software licences available for onboarding generation. Go to Software Licences section to add more.');
    }
    const software_list_names = software_list.map(software => software.name); 
    const documments_names = available_docs.map(doc => doc.name);
    try {
      const payload = {
        employee_name: employee.firstName + ' ' + employee.lastName,
        employee_email: employee.email,
        account_identifier: accountIdentifier,
        job_title: employee.contract.jobType,
        department: employee.contract.department,
        seniority: employee.contract.jobType.includes('Senior')
          ? 'Senior'
          : 'Junior',
        available_docs: documments_names,
        software_list: software_list_names
      };
      console.log('Payload for AI onboarding:', payload);
      //const url = 'https://codersden.app.n8n.cloud/webhook/bst-auto-generate-onboarding'
      const url = 'https://codersden.app.n8n.cloud/webhook/6a99820e-ae86-435c-ad10-fee8a8a35878'
      const response = await fetch(
        url,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        }
      );
      if (!response.ok) {
        throw new Error(
          `Failed running auto-generate onboarding: ${response.status}`
        );
      }

      const data = await response.json();
      console.log('Auto-Generated Onboarding data:', data);


      const responseProfile = await fetch(
        '/api/profile/' + employee.identifier + '/updateOnboardingStatus',
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );


      if (!responseProfile.ok) {
        throw new Error(`Failed updating profile: ${profileResponse.status}`);
      }

      return data;
    } catch (error) {
      console.error('Error running auto-generate onboarding:', error);
      throw error;
    }
  }
};
export default OnBoardingService;
